import React from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";


const BlogGrid = ({ allPosts, loading, currentPage }) => {
    return (
        <>
                {allPosts && allPosts.length > 0 ? (
                    allPosts.map((post, index) => (
                        <>
                            <div className="col-xl-3 col-lg-4 col-sm-6 col-12" key={post.id}>
                                <div className="blog-grid">
                                    <div className="blog-img">
                                        <div className="date">{post.created_at}</div>
                                        <Link to={`/post/details/${post.slug}`}>
                                            <LazyLoadImage
                                                alt={post.title}
                                                className=""
                                                effect="blur"
                                                src={post.thumbnail[0].data_url}
                                                width="100%"
                                                style={{}}
                                            />
                                        </Link>
                                    </div>
                                    <div className="blog-info">
                                        <h5><Link to={`/post/details/${post.slug}`}>{post.title}</Link></h5>
                                        <p>{post.short_description}</p>
                                        <div className="btn-bar">
                                            <Link to={`/post/details/${post.slug}`} className="px-btn-arrow">
                                                <span>Read More</span>
                                                <i className="arrow"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))
                ) : (
                    <div className="alert alert-primary" style={{ 'margin':'0 auto' }} role="alert">Sorry! no posts found!.</div>
                )}

                {loading && currentPage !== 1 && (
                    <>
                        {Array.from({ length: 8 }).map((_, index) => (
                            <div className="col-xl-3 col-lg-4 col-sm-6 col-12" key={index}>
                                <div className="ph-item p-0 border-0">
                                    <div className="ph-col-12 p-0">
                                        <div className="ph-picture"></div>
                                        <div className="ph-row">
                                            <div className="ph-col-6"></div>
                                            <div className="ph-col-4 empty"></div>
                                            <div className="ph-col-2"></div>
                                            <div className="ph-col-8"></div>
                                            <div className="ph-col-4 empty"></div>
                                            <div className="ph-col-12"></div>
                                            <div className="ph-col-6"></div>
                                            <div className="ph-col-6 empty"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                )}
        </>
    );
}

export default BlogGrid;
